import React, { useCallback } from 'react'

import { TextLink, UiPlusIcon, UiDeleteIcon } from '@octane/spark'
import FormSubsection from 'components/FormSubsection'
import { FieldKit } from 'containers/FormBuilder'
import { setFieldValueAndTouched } from 'form/fields/utils/fieldUtils'
import { FormikValues } from 'formik'

import { RemoveLink } from '../MarineWriteIn.styled'
import TrailerCollateralForm from './TrailerCollateralForm'

const BLANK_TRAILER = {
    condition: 'N',
    make: '',
    model: '',
    year: '',
}

interface Props {
    formik: FieldKit<FormikValues>
    prefilled?: boolean
}

function TrailerFormSubsection({ formik, prefilled }: Readonly<Props>) {
    const {
        marine: { trailer },
    } = formik.values

    const handleAddTrailer = useCallback(() => {
        if (trailer) {
            return
        }

        setFieldValueAndTouched(formik, 'marine.trailer', {
            ...BLANK_TRAILER,
        })
    }, [formik, trailer])

    const handleRemoveTrailer = useCallback(() => {
        setFieldValueAndTouched(formik, 'marine.trailer', null)
    }, [formik])

    return (
        <FormSubsection title="Trailer Details">
            {!trailer && !prefilled && (
                <TextLink
                    as="button"
                    endIcon={UiPlusIcon}
                    onClick={handleAddTrailer}
                    variant="simple"
                >
                    Add a Trailer
                </TextLink>
            )}
            {trailer && (
                <>
                    <TrailerCollateralForm
                        formik={formik}
                        prefilled={prefilled}
                    />
                    {!prefilled && (
                        <RemoveLink
                            endIcon={UiDeleteIcon}
                            onClick={handleRemoveTrailer}
                        >
                            Remove Trailer
                        </RemoveLink>
                    )}
                </>
            )}
        </FormSubsection>
    )
}

export default TrailerFormSubsection
